<template>
    <pop
        :customClass="`request-pop ${theme}`"
        :animation="'bottomToUp'"
        :style="{ height: height }"
    >
        <Request ref="request" :theme="theme" :submitText="submitText" />
    </pop>
</template>
<script>
import Request from './est-request.vue';
export default {
    components: { Request },
    props: ['theme', 'submitText', '_storeName'],
    data: function() {
        return {
            height: 0
        };
    },
    mounted() {
        let request = this.$refs.request;
        if (request) {
            this.height = request.$el.offsetHeight;
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
.request-pop {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    top: 0px;
    left: 0px;
    &.fashion {
        .icon-close {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(139, 147, 167, 0.5);
            z-index: var(--level-high);
            &:before {
                font-size: 12px;
                color: #fff;
            }
        }
    }
    &.classic,
    &.standard {
        .icon-close {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            z-index: var(--level-high);
            &:before {
                font-size: 12px;
            }
        }
    }
}
</style>
